// lodash
import startsWith from 'lodash/startsWith';

export default function isItemFabric(item = {}) {
  const {
    type,
    uom,
  } = item;
  return !!(uom && !startsWith(type, 'm2m'));
}
